import React from 'react';
import './FilterStyles.css';

const EDUCATION_LEVELS = [
  'No Qualifications',
  'Level 1',
  'Level 2',
  'Apprenticeship',
  'Level 3',
  'Level 4+'
];

const EducationFilter = ({ filter, onUpdate, onRemove }) => {
  const { minLevel = 0, maxLevel = 5 } = filter.values;

  const handleMinChange = (e) => {
    const newMin = parseInt(e.target.value);
    onUpdate({
      ...filter,
      values: {
        ...filter.values,
        minLevel: newMin,
        maxLevel: Math.max(newMin, maxLevel)
      }
    });
  };

  const handleMaxChange = (e) => {
    const newMax = parseInt(e.target.value);
    onUpdate({
      ...filter,
      values: {
        ...filter.values,
        minLevel: Math.min(minLevel, newMax),
        maxLevel: newMax
      }
    });
  };

  return (
    <div className="filter-container">
      <div className="filter-header">
        <h3>Education</h3>
        <button className="filter-remove-btn" onClick={onRemove}>×</button>
      </div>

      <div className="filter-section">
        <div className="range-display">
          <strong>Range:</strong> {EDUCATION_LEVELS[minLevel]} to {EDUCATION_LEVELS[maxLevel]}
        </div>

        <div className="dual-range-control">
          <div className="dual-range-wrapper">
            <input
              type="range"
              min="0"
              max="5"
              value={minLevel}
              onChange={handleMinChange}
              className="range-slider range-slider-min"
            />
            <input
              type="range"
              min="0"
              max="5"
              value={maxLevel}
              onChange={handleMaxChange}
              className="range-slider range-slider-max"
            />
          </div>
          <div className="dual-range-labels">
            <span className="range-label">{EDUCATION_LEVELS[minLevel]}</span>
            <span className="range-label">{EDUCATION_LEVELS[maxLevel]}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EducationFilter;
